module.exports = __webpack_public_path__ + "static/img/4.ed85cd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zncajzx/4.png
// module id = aLOk
// module chunks = 1